import { useEffect } from 'react';

import { useQuotation } from './useQuotation';

import { useBranch } from '../branches/useBranch';

import { useAuthUser } from '../auth/useAuthUser';

import { useCustomer } from '../useCustomer';

import { useEmployee } from '../employee/useEmployee';

import { getTodayDateString } from '../../utils/dateFormatters';
import { EmployeeFilterType } from '../../services/employees/EmployeeService';

const useQuotationHeader = () => {

    // =====================================================
    // 🔹 Quotation
    // =====================================================
    const {
        form,

        updateField,

        initialize,

        updateHeader,

        loading,

        fieldErrors,

        handlerResetQuotationFormOnly,
    } = useQuotation();

    // =====================================================
    // 🔹 Data
    // =====================================================
    const {
        fetchSalesBranchDropdown,

        branchDropdown,

        myBranch,

        fetchMyBranch,
    } = useBranch();

    const { hasRole } = useAuthUser();

    // Solo estos roles pueden asignar otra sucursal u otro vendedor a la
    // cotización; para el resto se toma siempre la sesión actual, sin
    // mostrar los selectores.
    const canOverrideAssignment =
        hasRole('ADMIN') || hasRole('SUPPORT') || hasRole('ACCOUNTANT');

    const {

        saveCustomer,

        handlerGetCustomersForDropdown,

        customersDropdown,

        openAddModal,

        closeAddModal,

        showRegistrationModal,

    } = useCustomer();

    const {
        employeeDropdown,

        fetchEmployeesDropdown,
    } = useEmployee();

    // =====================================================
    // 🚀 Init
    // =====================================================
    useEffect(() => {

        fetchSalesBranchDropdown();

        handlerGetCustomersForDropdown();

        fetchEmployeesDropdown(EmployeeFilterType.QUOTATIONS);

        fetchMyBranch();

    }, []);

    // =====================================================
    // 🏢 Sucursal por defecto (editable si tiene el rol)
    // =====================================================
    useEffect(() => {
        if (myBranch && !form.branch?.id) {
            updateField('branch', { id: myBranch.id, name: myBranch.name });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myBranch]);

    // =====================================================
    // 📅 Default Date
    // =====================================================
    useEffect(() => {

        if (
            !form.expirationDate
        ) {

            updateField(
                'expirationDate',
                getTodayDateString()
            );

        }

    }, [
        form.expirationDate,
        updateField,
    ]);

    // =====================================================
    // ✅ Actions
    // =====================================================
    const handlerInitializeQuotation = async () => {

        await initialize(form);

    };

    const handlerUpdateQuotationHeader = async () => {

        if (!form.id) {
            return;
        }

        await updateHeader(
            form.id,
            form
        );

    };

    // =====================================================
    // ✅ Return
    // =====================================================
    return {

        form,

        updateField,

        loading,

        fieldErrors,

        branchDropdown,

        canOverrideAssignment,

        customersDropdown,

        employeeDropdown,

        handlerInitializeQuotation,

        handlerUpdateQuotationHeader,

        handlerResetQuotationFormOnly,

        reloadCustomersDropdown:
            handlerGetCustomersForDropdown,

        saveCustomerQuick:
            saveCustomer,

        openCustomerModal:
            openAddModal,

        closeCustomerModal:
            closeAddModal,

        showCustomerModal:
            showRegistrationModal,
    };

};

export default useQuotationHeader;